import { debounce } from "./../../helpers/debounce";
import { getFormIdFromUrl } from "./../../helpers/getUrlParams";
import { api } from "./../api";
import { ApiDynamicPaths } from "./../api/paths";
import { ILayoutForBackEnd } from "./../../store/layout/types";

export class LayoutService {
    /**
     * set layout request
     *
     * @param  {IILayoutForBackEnd[]} data
     */
    static async setLayout(data: ILayoutForBackEnd[]) {
        debounce(
            "updateLayoutRequest",
            () => {
                api.post(ApiDynamicPaths({ form_id: getFormIdFromUrl() }).UPDATE_LAYOUT, data);
            },
            200,
        );
    }
}
